import { QueryClientProvider } from '@tanstack/react-query';

import { queryClient } from './queryCliente';
import { ReactQueryDevtoolsToggle } from './ReactQueryDevtoolsToggle';

import type { ReactNode } from 'react';

export function TanStackQueryProvider(props: { children: ReactNode }) {
  return (
    <QueryClientProvider client={queryClient}>
      {props.children}
      <ReactQueryDevtoolsToggle />
    </QueryClientProvider>
  );
}
